import { useEffect } from 'react'
import './App.css'
import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { configureSdk } from '@myio/energy-chart-sdk'
import { getThemeFromURL, applyTheme } from './utils/themeUtils'
import ManagementDashboard from './components/ManagementDashboard'
import TestComponent from './components/TestComponent'
import TelemetryChartsDemo from './components/TelemetryChartsDemo'
import { ManagementProvider } from './context/ManagementContext'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  useEffect(() => {
    // Configure SDK with API base URL
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    configureSdk({
      apiBaseUrl: baseUrl,
      defaultTimezone: 'America/Sao_Paulo'
    });

    // Apply theme from URL on initial load
    const theme = getThemeFromURL();
    applyTheme(theme);

    // Don't redirect to test-sdk.html - let management dashboard load
    // if (window.location.pathname === '/' && !window.location.pathname.includes('/management')) {
    //   window.location.href = '/test-sdk.html';
    // }
  }, []);

  return (
    <Sentry.ErrorBoundary 
      fallback={({ error, resetError }) => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>An error has occurred</h1>
          <p>{error?.toString() || 'Something went wrong'}</p>
          <button onClick={() => resetError()}>Try Again</button>
        </div>
      )}
      showDialog
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ManagementProvider>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <BrowserRouter>
                <Routes>
                  {/* Public routes - no authentication required */}
                  <Route path="/test" element={<TestComponent />} />
                  <Route path="/demo" element={<TelemetryChartsDemo />} />
                  
                  {/* Protected routes - require admin authentication */}
                  <Route 
                    path="/management/*" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <ManagementDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/*" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <ManagementDashboard />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </BrowserRouter>
            </div>
          </ManagementProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}

export default App
